import React from 'react';

/**
 * LmxText — muestra el texto de LMX con un markdown mínimo y SEGURO
 * (sin dangerouslySetInnerHTML): párrafos, saltos de línea, **negrita**,
 * *cursiva*, `código` y listas con "- ". Todo lo demás sale como texto.
 *
 *  <LmxText text={...} />            → bloque con párrafos
 *  <LmxText text={...} inline />     → una sola línea (para el renglón plegado)
 */
const INLINE = /(\*\*[^*]+\*\*|`[^`]+`|\*[^*\s][^*]*\*)/g;

const inline = (str, keyBase) => String(str).split(INLINE).filter(Boolean).map((part, i) => {
  const k = `${keyBase}-${i}`;
  if (part.startsWith('**') && part.endsWith('**') && part.length > 4) return <strong key={k}>{part.slice(2, -2)}</strong>;
  if (part.startsWith('`') && part.endsWith('`') && part.length > 2) return <code key={k}>{part.slice(1, -1)}</code>;
  if (part.startsWith('*') && part.endsWith('*') && part.length > 2) return <em key={k}>{part.slice(1, -1)}</em>;
  return <React.Fragment key={k}>{part}</React.Fragment>;
});

/** Texto plano de una línea: sin marcas, con espacios normalizados. */
export const lmxPlain = (text) => String(text || '')
  .replace(/\*\*([^*]+)\*\*/g, '$1').replace(/`([^`]+)`/g, '$1')
  .replace(/^\s*[-•]\s+/gm, '').replace(/\s+/g, ' ').trim();

export const LmxText = ({ text, inline: oneLine = false }) => {
  if (!text) return null;
  if (oneLine) return <>{inline(lmxPlain(text).replace(/\*/g, ''), 'l')}</>;
  // Párrafos separados por línea en blanco; dentro de cada uno, las líneas que
  // empiezan con "- " o "• " se agrupan en una lista.
  const out = [];
  String(text).trim().split(/\n{2,}/).forEach((block, b) => {
    let para = []; let list = [];
    const flushPara = () => {
      if (!para.length) return;
      const lines = para; para = [];
      out.push(
        <p key={`p${b}-${out.length}`} className="lmx-md-p">
          {lines.map((l, i) => <React.Fragment key={i}>{i > 0 && <br />}{inline(l, `${b}-${out.length}-${i}`)}</React.Fragment>)}
        </p>,
      );
    };
    const flushList = () => {
      if (!list.length) return;
      const items = list; list = [];
      out.push(
        <ul key={`u${b}-${out.length}`} className="lmx-md-list">
          {items.map((l, i) => <li key={i}>{inline(l, `${b}-${out.length}-${i}`)}</li>)}
        </ul>,
      );
    };
    block.split('\n').forEach((line) => {
      const m = line.match(/^\s*[-•]\s+(.*)$/);
      if (m) { flushPara(); list.push(m[1]); } else { flushList(); para.push(line); }
    });
    flushPara(); flushList();
  });
  return <>{out}</>;
};

export default LmxText;
